export const PACKAGE_NAME = 'jiraGrowthUtils';
